import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Chip,
  Tooltip,
  TextField,
  Typography,
  InputAdornment,
  Menu,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { Clear } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import styles from "./index.module.css";
import select from "../../../utils/select";

import KPTable from "../../../components/KPTable";
import ScientificResearchUpdateModal from "../ScientificResearchUpdateModal";
import ScientificResearchDeleteModal from "../ScientificResearchDeleteModal";
import ScientificResearchHistoryModal from "../ScientificResearchHistoryModal";
import { WorkflowFilterBar, applyConditions, ExportExcelButton } from "../../../components/WorkflowStatus";

import { statisticUnaccepted } from "../../../reducer/profile/action";
import {
  acceptScientificResearch,
  updateScientificResearch,
  requestRevisionScientificResearch,
} from "../../../reducer/scientificResearch/action";
import {
  acceptScientificResearchOther,
  updateScientificResearchOther,
} from "../../../reducer/scientificResearchOther/action";
import { changePages } from "../../../reducer/home/action";
import { KPTextform } from "../../../components/KPTComponents";
import { exportExcel } from "../utils/exportExcel";

const listFilter = [
  {
    value: "journalInternational",
    type: "scientificResearchJournal",
    title: "Tạp chí quốc tế",
    checkFunction: (e) => e.journal && !e.scientificResearch.accepted,
  },
  {
    value: "journalDomestic",
    type: "scientificResearchJournalDomestic",
    title: "Tạp chí trong nước",
    checkFunction: (e) => e.journalDomestic && !e.scientificResearch.accepted,
  },
  {
    value: "conference",
    type: "scientificResearchConference",
    title: "Hội thảo quốc tế",
    checkFunction: (e) => e.conference?.level === "international" && !e.scientificResearch.accepted,
  },
  {
    value: "conferenceDomestic",
    type: "scientificResearchConferenceDomestic",
    title: "Hội thảo trong nước",
    checkFunction: (e) => e.conference?.level === "domestic" && !e.scientificResearch.accepted,
  },
  {
    value: "chapter",
    type: "chapterJournal",
    title: "Chương sách",
    checkFunction: (e) => e.scientificResearch.type === "chapterJournal" && !e.scientificResearch.accepted,
  },
  // {
  //   value: "workingPaper",
  //   type: "working",
  //   title: "Working Paper",
  //   checkFunction: (e) => false,
  // },
  // {
  //   value: "other",
  //   type: "scientificResearchOther",
  //   title: "Tạp chí khác",
  //   checkFunction: (e) => false,
  // },
];

// Derive a single status string for FE rendering. revision_status takes
// priority over `accepted` so a row that admin asked to re-declare is shown
// as "Yêu cầu khai lại" even if it was previously approved.
const deriveStatus = (row) => {
  if (row?.revisionStatus === "requested") return "revisionRequested";
  if (row?.revisionStatus === "resubmitted") return "resubmitted";
  if (row?.accepted) return "approved";
  return "pending";
};

const STATUS_META = {
  pending: { label: "Chờ duyệt", bg: "#9e9e9e", color: "#fff" },
  approved: { label: "Đã duyệt", bg: "#43a047", color: "#fff" },
  revisionRequested: { label: "Yêu cầu khai lại", bg: "#e53935", color: "#fff" },
  resubmitted: { label: "Đã khai lại — chờ duyệt", bg: "#1e88e5", color: "#fff" },
};

const fmtDateTime = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

function ScientificResearchTable(props) {
  const [editting, setEditting] = useState(null);
  const [updating, setUpdating] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [historyRow, setHistoryRow] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  // "Yêu cầu khai lại" modal state.
  const [revisionRow, setRevisionRow] = useState(null); // the SR row being revisioned
  const [revisionReason, setRevisionReason] = useState("");
  const [revisionSubmitting, setRevisionSubmitting] = useState(false);

  // Dynamic "Bộ lọc nâng cao" conditions. Stored at the table level so they
  // survive tab switches between filter types. Reset on `filter` change so
  // the user doesn't carry a "Người duyệt = X" filter from journals into
  // chapters and get an empty table without explanation.
  const [advancedConditions, setAdvancedConditions] = useState([]);
  useEffect(() => {
    setAdvancedConditions([]);
  }, [props.filter]);

  const handleUpdate = (e) => setUpdating(e);
  const handleEditYear = (e) => setEditting(e);

  useEffect(() => {
    // sessionStorage.setItem('ScientificResearchPage', parseInt(sessionStorage.getItem('ScientificResearchPage') || 0));
    sessionStorage.setItem("ScientificResearchPage", 0);
  }, []);

  const handleDelete = (event, e) => {
    setDeleting(e.id);
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (value) => {
    setEditting({
      ...editting,
      dashboardYear: value,
    });
  };

  const handleChangePurpose = (value, editting) => {
    // // console.log(value, editting);
    props.updateScientificResearch(editting.id, {
      ...editting,
      purposeId: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // change scientific other
    // if (props.filter !== 'other') {
    props.updateScientificResearch(editting.id, editting);
    // } else {
    //   props.updateScientificResearchOther(editting.id, editting);
    // }
    setEditting(null);
  };

  const handleClear = () => {
    // change scientific other
    // if (props.filter !== 'other') {
    props.updateScientificResearch(editting.id, {
      ...editting,
      dashboardYear: null,
    });
    // } else {
    //   props.updateScientificResearchOther(editting.id, {...editting, dashboardYear: null});
    // }
    setEditting(null);
  };

  const handleAccept = (e) => {
    // change scientific other
    // if (props.filter !== 'other') {
    props.acceptScientificResearch(e.id, !e.accepted, props.filter).then((success) => {
      if (success) {
        props.statisticUnaccepted({
          departmentId: 0,
          profileId: props.profile?.id,
        });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });
    // } else {
    //   props.acceptScientificResearchOther(e.id, !e.accepted);
    // }
  };

  const getPublicationTitle = (item) => {
    switch (props.filter) {
      case "journalDomestic":
        return (
          (item.publication?.title
            ? `${item.publication?.title} (${item.publication?.publisher})`
            : item?.otherTitle) ?? "N/A"
        );
      case "conference":
        return (
          (item.publication?.title
            ? `${item.publication?.title} (Hội thảo rank ${item.publication?.rank})`
            : item?.otherTitle
              ? item?.otherTitle
              : item?.journalTitle) ?? "N/A"
        );
      default:
        return (
          (item.publication?.title
            ? `${item.publication?.title} (${item.publication?.coreCollection}, ${item.publication?.sjrBestQuartile})`
            : item?.otherTitle
              ? item?.otherTitle
              : item?.journalTitle) ?? "N/A"
        );
    }
    // (item.publication?.title? (`${item.publication?.title} (${item.publication?.coreCollection},  ${item.publication?.sjrBestQuartile}-${item.publication?.rank})`) : (item?.otherTitle? item?.otherTitle : item?.journalTitle))
  };

  const list = [];
  if (props.type === "all") {
    switch (props.filter) {
      case "journalInternational": {
        props.listScientificResearch.forEach((e) => {
          if (e?.scientificResearch?.type === "scientificResearchJournal" && e?.scientificResearch?.purposeId !== 4)
            list.push({
              ...e.scientificResearch,
              publication: e.journal,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
        });
        break;
      }
      case "journalDomestic": {
        props.listScientificResearch.forEach((e) => {
          if (
            e?.scientificResearch?.type === "scientificResearchJournalDomestic" &&
            e?.scientificResearch?.purposeId !== 4
          )
            list.push({
              ...e.scientificResearch,
              publication: e.journalDomestic,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
        });
        break;
      }
      case "conference": {
        props.listScientificResearch.forEach((e) => {
          if (e?.scientificResearch?.type === "scientificResearchConference" && e?.scientificResearch?.purposeId !== 4)
            list.push({
              ...e.scientificResearch,
              publication: e.conference,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
        });
        break;
      }
      case "conferenceDomestic": {
        props.listScientificResearch.forEach((e) => {
          if (
            e?.scientificResearch?.type === "scientificResearchConferenceDomestic" &&
            e?.scientificResearch?.purposeId !== 4
          )
            list.push({
              ...e.scientificResearch,
              publication: e.conference,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
        });
        break;
      }
      case "chapter": {
        props.listScientificResearch.forEach((e) => {
          if (e?.scientificResearch?.type === "chapterJournal" && e?.scientificResearch?.purposeId !== 4) {
            list.push({
              ...e.scientificResearch,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
          }
        });
        break;
      }
      case "workingPaper": {
        props.listScientificResearch.forEach((e) => {
          if (e?.scientificResearch?.type === "working" && e?.scientificResearch?.purposeId !== 4) {
            list.push({
              ...e.scientificResearch,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
          }
        });
        break;
      }
      // change scientific other
      case "other": {
        props.listScientificResearch.forEach((e) => {
          if (e?.scientificResearch?.type === "scientificResearchOther") {
            list.push({
              ...e.scientificResearch,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
          }
        });
        break;
      }
      // case 'other': {
      //   props.listScientificResearchOther.forEach((e) => {
      //     list.push({
      //       ...e.scientificResearchOther,
      //       filter: props.filter,
      //       submissionYear:  new Date(e.scientificResearch.submissionDay).getFullYear(),
      //     })
      //   })
      //   break;
      // }
      default: {
        break;
      }
    }
  } else {
    switch (props.filter) {
      case "journalInternational": {
        props.listScientificResearchById.forEach((e) => {
          if (e?.scientificResearch?.type === "scientificResearchJournal")
            list.push({
              ...e.scientificResearch,
              publication: e.journal,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
        });
        break;
      }
      case "journalDomestic": {
        props.listScientificResearchById.forEach((e) => {
          if (e?.scientificResearch?.type === "scientificResearchJournalDomestic")
            list.push({
              ...e.scientificResearch,
              publication: e.journalDomestic,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
        });
        break;
      }
      case "conference": {
        // // console.log(props.listScientificResearchById);
        props.listScientificResearchById.forEach((e) => {
          if (e?.scientificResearch?.type === "scientificResearchConference")
            list.push({
              ...e.scientificResearch,
              publication: e.conference,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
        });
        break;
      }
      case "conferenceDomestic": {
        props.listScientificResearchById.forEach((e) => {
          if (e?.scientificResearch?.type === "scientificResearchConferenceDomestic")
            list.push({
              ...e.scientificResearch,
              publication: e.conference,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
        });
        break;
      }
      case "chapter": {
        props.listScientificResearchById.forEach((e) => {
          if (e?.scientificResearch?.type === "chapterJournal") {
            list.push({
              ...e.scientificResearch,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
          }
        });
        break;
      }
      case "workingPaper": {
        props.listScientificResearchById.forEach((e) => {
          if (e?.scientificResearch?.type === "working") {
            list.push({
              ...e.scientificResearch,
              filter: props.filter,
              // submissionYear:  new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
          }
        });
        break;
      }
      // change scientific other
      case "other": {
        props.listScientificResearchById.forEach((e) => {
          if (e?.scientificResearch?.type === "scientificResearchOther") {
            list.push({
              ...e.scientificResearch,
              filter: props.filter,
              submissionYear: new Date(e.scientificResearch.submissionDay).getFullYear(),
            });
          }
        });
        break;
      }
      // case 'other': {
      //   props.listScientificResearchOtherById.forEach((e) => {
      //     list.push({
      //       ...e.scientificResearchOther,
      //       filter: props.filter,
      //       submissionYear:  new Date(e.scientificResearchOther.submissionDay).getFullYear(),
      //     })
      //   })
      //   break;
      // }
      default: {
        break;
      }
    }
  }

  const columns = [
    {
      title: <b>Tác vụ</b>,
      key: "action",
      width: "12%",
      render: (value, row) =>
        row?.id !== editting?.id ? (
          <>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="primary"
              onClick={() => handleUpdate(row)}
            >
              Chi tiết
            </Typography>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="primary"
              onClick={() => setHistoryRow(row)}
            >
              Lịch sử
            </Typography>
            {row.locked ? (
              <Typography className="table-action-buton" variant="caption" color="textPrimary">
                {`Đã khóa ${
                  (row.locked === "kpi" && "KPI") ||
                  (row.locked === "reward" && "thưởng") ||
                  (row.locked === "timeResearch" && "giờ nghiên cứu")
                }`}
              </Typography>
            ) : (
              <>
                {((props.type !== "all" && (!props.selectedProfileId || props.role === "sudo-admin")) ||
                  (props.type === "all" && props.role === "sudo-admin")) &&
                  !row.accepted && (
                    <Typography
                      className="table-action-buton"
                      variant="caption"
                      color="secondary"
                      onClick={(event) => handleDelete(event, row)}
                    >
                      Xoá
                    </Typography>
                  )}
                {props.role === "sudo-admin" && props.filter !== "workingPaper" && row.purposeId !== 4 && (
                  <>
                    <Typography
                      className="table-action-buton"
                      variant="caption"
                      color="primary"
                      onClick={(event) => handleAccept(row)}
                    >
                      {row.accepted ? "Hủy duyệt" : "Duyệt"}
                    </Typography>
                    {/* Admin asks user to re-declare. Hidden when the row is
                        already in revision_requested state (no point asking
                        twice without a change). */}
                    {row.revisionStatus !== "requested" && (
                      <Typography
                        className="table-action-buton"
                        variant="caption"
                        style={{ color: "#e53935" }}
                        onClick={() => {
                          setRevisionRow(row);
                          setRevisionReason(row.revisionReason || "");
                        }}
                      >
                        Yêu cầu khai lại
                      </Typography>
                    )}
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <Typography className="table-action-buton" variant="caption" color="primary" onClick={handleSubmit}>
              Lưu
            </Typography>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="secondary"
              onClick={() => setEditting(null)}
            >
              Huỷ
            </Typography>
          </>
        ),
    },
    {
      title: <b>Tên công bố</b>,
      key: "title",
      width: props.role === "sudo-admin" ? "25%" : "35%",
      sortable: true,
      searchable: true,
      render: (value, row) => <div onClick={() => handleUpdate(row)}>{value}</div>,
    },
    {
      title: <b>Tác giả</b>,
      key: "listAuthorString",
      width: "18%",
      searchable: true,
    },
    {
      title: <b>Năm công bố</b>,
      key: "acceptedDay",
      width: "8%",
      sortable: true,
      sorter: (a, b) =>
        parseInt(new Date(a.acceptedDay).getFullYear()) - parseInt(new Date(b.acceptedDay).getFullYear()),
      render: (value) => (value ? new Date(value).getFullYear() : "—"),
    },
    {
      title: <b>Mục đích</b>,
      key: "purposeId",
      width: "12%",
      type: "include",
      filters: props.purposes.map((e) => ({
        value: e.id,
        text: e.description,
      })),
      onFilter: (value, row) => row.filter((e) => value.includes(e.purposeId)),
      render: (value) => props.purposes.find((e) => e.id === value)?.description,
    },
    {
      title: <b>Người kê khai</b>,
      key: "createdByName",
      width: "10%",
      searchable: true,
      render: (value) => (value ? value : <span style={{ color: "#bbb" }}>—</span>),
    },
    {
      title: <b>Người duyệt</b>,
      key: "approvedByName",
      width: "10%",
      render: (value) => (value ? value : <span style={{ color: "#bbb" }}>—</span>),
    },
    {
      title: <b>Thời gian duyệt</b>,
      key: "approvedAt",
      width: "10%",
      sortable: true,
      sorter: (a, b) => new Date(a.approvedAt || 0) - new Date(b.approvedAt || 0),
      render: (value) => (value ? fmtDateTime(value) : <span style={{ color: "#bbb" }}>—</span>),
    },
  ];

  if (props.filter !== "workingPaper")
    columns.splice(3, 0, {
      title: <b>Trạng thái</b>,
      // Derived from {accepted, revisionStatus}. Stored in `_status` on each
      // row (added in the rows.map below) so KPTable's "include" filter can
      // operate on a single value.
      key: "_status",
      width: "12%",
      render: (_, row) => {
        if (row.purposeId === 4) {
          return <Chip size="small" color="primary" label="Công bố cũ" variant="outlined" />;
        }
        const s = STATUS_META[row._status] || STATUS_META.pending;
        return (
          <Tooltip
            title={row.revisionStatus === "requested" && row.revisionReason ? `Lý do: ${row.revisionReason}` : ""}
            placement="top"
          >
            <Chip
              size="small"
              label={s.label}
              style={{ backgroundColor: s.bg, color: s.color, fontWeight: 500 }}
            />
          </Tooltip>
        );
      },
      type: "include",
      filters: Object.entries(STATUS_META).map(([value, meta]) => ({ value, text: meta.label })),
      onFilter: (value, rows) => rows.filter((e) => value.includes(e._status)),
    });

  if (props.filter !== "workingPaper" && props.filter !== "chapter")
    columns.splice(2, 0, {
      title: <b>Tên tạp chí / hội thảo</b>,
      key: "publicationTitle",
      width: "20%",
      sortable: true,
      searchable: true,
    });

  // Pre-compute table rows with derived fields, then apply the advanced
  // filter on top so KPTable sees only matching rows. The advanced filter
  // composes WITH the KPTable per-column filters (KPTable runs on whatever
  // we pass in), so admins can combine "Trạng thái = Đã duyệt" via the
  // header filter AND "Người duyệt = Nguyễn X" via the advanced bar.
  const enrichedRows = list.map((item) => ({
    ...item,
    listAuthorString: item?.listAuthor?.join(", "),
    publicationTitle: getPublicationTitle(item),
    _status: deriveStatus(item),
  }));
  const filteredRows = applyConditions(enrichedRows, advancedConditions);

  // SR table reuses `department` from the profile reducer; the Management
  // tab also forwards a `department` ID (selected unit). We look that ID up
  // in the global departments list for the Excel header.
  const departmentName = (props.allDepartments || []).find(
    (d) => d.id === (typeof props.department === "number" ? props.department : null),
  )?.name;

  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 4 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <WorkflowFilterBar
            conditions={advancedConditions}
            onChange={setAdvancedConditions}
            rows={enrichedRows}
          />
        </div>
        <ExportExcelButton rows={filteredRows} workType="scientificResearch" />
      </div>
      <KPTable
        shadow="none"
        pageName="ScientificResearchPage"
        rowsPerPage={10}
        maxHeight="calc(100vh - 320px)"
        columns={columns}
        rows={filteredRows}
        loading={props.isFetching}
      />
      <Menu
        open={!!props.reportAnchorEl}
        anchorEl={props.reportAnchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => props.setReportAnchorEl(null)}
        classes={{ paper: styles.paper }}
      >
        <Box width={300} padding={1}>
          <KPTextform
            textForm={[
              { xs: 12, key: "startAt", type: "date", label: "Ngày bắt đầu" },
              { xs: 12, key: "finishAt", type: "date", label: "Ngày kết thúc" },
              {
                xs: 12,
                key: "export",
                type: "render",
                render: () => (
                  <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    style={{ height: 35 }}
                    onClick={() =>
                      exportExcel(
                        list.filter((e) => {
                          const startDate = new Date(props.date.startAt);
                          const finishDate = new Date(props.date.finishAt);
                          const startMonth = startDate.getMonth() + 1;
                          const startYear = startDate.getFullYear();
                          const finishMonth = finishDate.getMonth() + 1;
                          const finishYear = finishDate.getFullYear();
                          const _date = new Date(e.acceptedDay);
                          const month = e.acceptedMonth || 1;
                          const year = _date.getFullYear();

                          return (
                            (startYear - 1) * 12 + startMonth <= (year - 1) * 12 + month &&
                            (year - 1) * 12 + month <= (finishYear - 1) * 12 + finishMonth
                          );
                        }),
                      )
                    }
                  >
                    Xuất file Excel
                  </Button>
                ),
              },
            ]}
            values={props.dateString}
            setValues={props.setDateString}
          />
        </Box>
      </Menu>
      <ScientificResearchUpdateModal
        adminTab={props.adminTab}
        filter={props.filter}
        updating={updating}
        setUpdating={setUpdating}
        other={props.other}
        type={listFilter.find((e) => e.value === props.filter)?.type}
      />
      <ScientificResearchDeleteModal
        filter={props.filter}
        deleting={deleting}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        other={props.other}
      />
      <ScientificResearchHistoryModal open={!!historyRow} row={historyRow} onClose={() => setHistoryRow(null)} />

      {/* "Yêu cầu khai lại" modal — admin enters a reason that the author
          sees in their listing + email notification. Min 10 chars enforced
          server-side; we also disable Submit until the input is long enough. */}
      <Dialog
        open={!!revisionRow}
        onClose={() => {
          if (!revisionSubmitting) {
            setRevisionRow(null);
            setRevisionReason("");
          }
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Yêu cầu khai lại</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" style={{ marginBottom: 12, color: "#555" }}>
            Bài: <b>{revisionRow?.title}</b>
          </Typography>
          <Typography variant="caption" style={{ display: "block", color: "#666", marginBottom: 4 }}>
            Lý do (tối thiểu 10 ký tự). Người kê khai sẽ nhận lý do này qua email + thấy trên bảng công trình
            của họ.
          </Typography>
          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={4}
            variant="outlined"
            placeholder="Ví dụ: Vui lòng cập nhật DOI cho bài và đính kèm file PDF bản chính thức."
            value={revisionReason}
            onChange={(e) => setRevisionReason(e.target.value)}
            disabled={revisionSubmitting}
          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={revisionSubmitting}
            onClick={() => {
              setRevisionRow(null);
              setRevisionReason("");
            }}
          >
            Huỷ
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={revisionSubmitting || (revisionReason || "").trim().length < 10}
            onClick={async () => {
              setRevisionSubmitting(true);
              const ok = await props.requestRevisionScientificResearch(
                revisionRow.id,
                revisionReason.trim(),
              );
              setRevisionSubmitting(false);
              if (ok) {
                setRevisionRow(null);
                setRevisionReason("");
                // Cheap refresh: bump statisticUnaccepted so the list reloads.
                if (props.profile?.id) {
                  props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
                }
              }
            }}
          >
            {revisionSubmitting ? "Đang gửi..." : "Gửi yêu cầu"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  workPages: select(state, "homeReducer", "workPages"),
  listJournal: select(state, "journalReducer", "listV2"),
  department: select(state, "profileReducer", "department"),
  filter: select(state, "scientificResearchReducer", "filter"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  isFetching: select(state, "scientificResearchReducer", "isFetching"),
  listScientificResearch: select(state, "scientificResearchReducer", "listFiltered"),
  listScientificResearchById: select(state, "scientificResearchReducer", "listById"),
  listScientificResearchOther: select(state, "scientificResearchOtherReducer", "list"),
  listScientificResearchOtherById: select(state, "scientificResearchOtherReducer", "listById"),
  allDepartments: select(state, "departmentReducer", "departments"),
});

const mapDispatchToProps = (dispatch) => ({
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  updateScientificResearch: (id, payload) => dispatch(updateScientificResearch(id, payload)),
  acceptScientificResearchOther: (id, accept) => dispatch(acceptScientificResearchOther(id, accept)),
  updateScientificResearchOther: (id, payload) => dispatch(updateScientificResearchOther(id, payload)),
  acceptScientificResearch: (id, accept, filter) => dispatch(acceptScientificResearch(id, accept, filter)),
  requestRevisionScientificResearch: (id, reason) => dispatch(requestRevisionScientificResearch(id, reason)),
  changePages: (id, newPage) => dispatch(changePages(id, newPage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ScientificResearchTable));

